module.exports = __webpack_public_path__ + "img/mydessk-black.b315a8a2.svg";